import React, { useState } from "react";
import { Card, Box, IconButton, Menu, MenuItem } from "@mui/material";
import SoftBox from "components/SoftBox";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EnhancedTableHead from "pages/components/common/EnhancedTableHead";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import DashboardLayout from "pages/components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/DashboardNavbar";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import SoftTypography from "components/SoftTypography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import RemoveAssetsModel from "../VendorListings/RemoveAssets";
import { tablePaperStyle } from "pages/components/common/Styles";

const staticUsers = [
  {
    id: 1,
    location: "India",
    asset: "68B6B33B7E88, Ciocca_Subfeed_Two, 68B6B33DB080, 68B6B33DB084, 68B6B33DB06C1",
    createdAt: "2025-03-04T10:30:00Z",
  },
  {
    id: 2,
    location: "America",
    asset: "68B6B33B7E88, Ciocca_Subfeed_Two, 68B6B33DB080, 68B6B33DB084, 68B6B33DB06C1",
    createdAt: "2025-03-03T15:45:00Z",
  },
  {
    id: 3,
    location: "Russia",
    asset: "68B6B33B7E88, Ciocca_Subfeed_Two, 68B6B33DB080, 68B6B33DB084, 68B6B33DB06C1",
    createdAt: "2025-03-02T08:20:00Z",
  },
  {
    id: 4,
    location: "China",
    asset: "68B6B33B7E88, Ciocca_Subfeed_Two, 68B6B33DB080, 68B6B33DB084, 68B6B33DB06C1",
    createdAt: "2025-03-03T15:45:00Z",
  },
  {
    id: 5,
    location: "Canada",
    asset: "68B6B33B7E88, Ciocca_Subfeed_Two, 68B6B33DB080, 68B6B33DB084, 68B6B33DB06C1",
    createdAt: "2025-03-02T08:20:00Z",
  },
];

const ViewVendorDetails = () => {
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [filters, setFitters] = useState({
    keyword: "",
    sensorCategoryId: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("created_at");
  const [pageSize, setPageSize] = useState(10);
  const [selected, setSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [removeAssets, setRemoveAssets] = useState(false);
  const { error, data } = useSelector((state) => state.users.getUserListingData);

  /**
   * Handle page change and refeacth data
   *
   * @param {*} event
   * @param {*} newPage
   */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /**
   * On change page size
   *
   * @param {*} event
   */
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  /**
   * Handle sorting change
   *
   * @param {*} event
   * @param {*} property
   */
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Handle action menu open/close
  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = (asset) => {
    setRemoveAssets(true);
    handleMenuClose();
  };

  const handleSearch = (users) =>
    users.filter((user) => user.email?.toLowerCase() || `${user.firstName} ${user.lastName}`);

  const filteredUsers = handleSearch((data?.users && data?.users.length > 0 && data?.users) || []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Link to={""}>
          <SoftTypography
            variant="h5"
            fontSize="medium"
            mb={2}
            component="a"
            onClick={() => navigate(-1)}
            display="flex"
            alignItems="center"
            color="info"
          >
            <KeyboardBackspaceIcon fontSize="medium" sx={{ mr: 0.5 }} /> Go Back
          </SoftTypography>
        </Link>
        <Card sx={{ padding: 3 }}>
          <SoftTypography variant="h4" fontWeight="bold" mb={2}>
            Assigned Assets
          </SoftTypography>
          <Paper sx={tablePaperStyle}>
            <Box>
              {loading ? (
                <Skeleton variant="rectangular" height={300} animation="wave" />
              ) : (
                <>
                  <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={filteredUsers.length}
                        headCells={headCells}
                      />

                      <TableBody>
                        {staticUsers.length === 0 && (
                          <TableRow key={1}>
                            <TableCell colSpan={8} align="center">
                              No records found.
                            </TableCell>
                          </TableRow>
                        )}

                        {staticUsers.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>
                              <SoftBox>
                                {row.location?.address || row.location?.name || "--"}
                              </SoftBox>
                            </TableCell>
                            <TableCell>
                              <SoftBox>{row.asset ? row.asset : "--"}</SoftBox>
                            </TableCell>
                            <TableCell align="left">
                              {row.createdAt
                                ? dayjs(row.createdAt).format("YYYY-MM-DD hh:mm:ss A")
                                : "-"}
                            </TableCell>
                            <TableCell>
                              <IconButton onClick={(event) => handleMenuOpen(event, row)}>
                                <MoreVertIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Menu
                    id="menu-basic"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleDelete}>Remove asset</MenuItem>
                  </Menu>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={totalRecords ?? 0}
                    rowsPerPage={pageSize ?? 10}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
              )}
            </Box>
          </Paper>
          <RemoveAssetsModel
            open={removeAssets}
            handleClose={() => {
              setRemoveAssets(false);
            }}
            refresh={refreshRecords}
            setRefresh={setRefreshRecords}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ViewVendorDetails;

const headCells = [
  {
    id: "LocationId",
    numeric: true,
    disablePadding: true,
    label: "Location",
    sortable: false,
  },
  {
    id: "assets",
    numeric: true,
    disablePadding: true,
    label: "Assined Assets",
    sortable: false,
  },
  {
    id: "assinedDate",
    numeric: false,
    disablePadding: false,
    label: "Assigned date",
    sortable: false,
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    sortable: false,
  },
];
